<div class="modal-header">
    <div class="title">
        <h2 class="modal-title">Modifier mes informations</h2>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body d-flex flex-column ">
    <div class="info-modify">
        <div class="container pwd-block">
            <form [formGroup]="form">
                <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Mot de passe actuel</mat-label>
                    <mat-pass-toggle-visibility #toggleCurrentPwd matSuffix></mat-pass-toggle-visibility>
                    <input matInput [type]="toggleCurrentPwd.type" required placeholder="Mot de passe actuel"
                        formControlName="oldPassword">
                    <mat-error *ngIf="form.controls['oldPassword'].invalid">Le mot de passe est obligatoire</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" style="width: 100%" [color]="passwordComponent.color">
                    <mat-label>Nouveau mot de passe</mat-label>
                    <mat-pass-toggle-visibility #toggleNewPwd matSuffix></mat-pass-toggle-visibility>
                    <input matInput #password [type]="toggleNewPwd.type" required placeholder="Nouveau mot de passe"
                        formControlName="password" (focus)="inputPwdFocus = true" (blur)="inputPwdFocus = false">
                    <mat-error *ngIf="form.controls.password.hasError('maxlength')">Le mot de passe ne doit pas dépasser
                        30 caractères</mat-error>
                    <mat-error *ngIf="form.controls['password'].value.length===0">Le mot de passe est obligatoire
                    </mat-error>
                    <mat-hint align="end" aria-live="polite">
                        {{password.value.length}} / {{passwordComponent.max}}
                    </mat-hint>
                </mat-form-field>

                <mat-password-strength #passwordComponent [password]="password.value">
                </mat-password-strength>

                <mat-password-strength-info *ngIf="inputPwdFocus"
                    [lowerCaseCriteriaMsg]="'contient au moins une minuscule'"
                    [upperCaseCriteriaMsg]="'contient au moins une majuscule'"
                    [digitsCriteriaMsg]="'contient au moins un chiffre'"
                    [specialCharsCriteriaMsg]="'contient au moins un caractère spécial'"
                    [minCharsCriteriaMsg]="'contient au moins 8 caractères'" [passwordComponent]="passwordComponent">
                </mat-password-strength-info>

                <mat-form-field appearance="outline" style="width: 100%; margin-top: 1rem;">
                    <mat-label>Confirmer le nouveau mot de passe</mat-label>
                    <mat-pass-toggle-visibility #toggleNewPwdConfirmed matSuffix></mat-pass-toggle-visibility>
                    <input matInput [type]="toggleNewPwdConfirmed.type" required
                        placeholder="Confirmer le nouveau mot de passe" formControlName="confirmedPassword">
                    <mat-error
                        *ngIf="form.controls['confirmedPassword'].pristine || form.controls['confirmedPassword'].errors?.MatchPassword">
                        Les mots de passe ne correspondent pas</mat-error>
                </mat-form-field>
            </form>
        </div>
    </div>
    <div class="col-sm-12 d-flex flex-column modify-block">
        <button class="modify" (click)="saveModification()">
            Sauvegarder les modifications
        </button>
    </div>
</div>